const MEDIA_PROXY_PREFIX = "/__media_proxy";
const MEDIA_STREAM_PREFIX = "/media";

function isLocalDevHost(hostname: string) {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "0.0.0.0";
}

function extractBackendUploadsPath(url: URL) {
  if (url.pathname.startsWith("/uploads/")) {
    return url.pathname;
  }

  const tenantPathMatch = url.pathname.match(/\/t\/[^/]+(\/uploads\/.+)$/);
  if (tenantPathMatch?.[1]) {
    return tenantPathMatch[1];
  }

  const match = url.pathname.match(/\/media(\/uploads\/.+)$/);
  return match?.[1] ?? "";
}

function shouldRewriteToFrontendOrigin(parsed: URL, location: Pick<Location, "origin" | "hostname" | "protocol">) {
  if (parsed.hostname === location.hostname || isLocalDevHost(parsed.hostname)) {
    return true;
  }

  return /\/t\/[^/]+\/uploads\/.+$/.test(parsed.pathname);
}

export function rewriteMediaUrl(
  value: string | null | undefined,
  location: Pick<Location, "origin" | "hostname" | "protocol"> | null = typeof window === "undefined" ? null : window.location,
) {
  if (!value) {
    return value ?? undefined;
  }

  let parsed: URL;
  try {
    parsed = new URL(value, location?.origin ?? "http://localhost");
  } catch {
    return value;
  }

  if (location && location.protocol === "https:" && parsed.protocol === "http:" && parsed.hostname === location.hostname) {
    parsed.protocol = "https:";
    value = parsed.toString();
  }

  const uploadsPath = extractBackendUploadsPath(parsed);
  if (location && uploadsPath && shouldRewriteToFrontendOrigin(parsed, location)) {
    if (!isLocalDevHost(location.hostname)) {
      return `${location.origin}${uploadsPath}`;
    }

    return `${location.origin}${MEDIA_PROXY_PREFIX}${MEDIA_STREAM_PREFIX}${uploadsPath}`;
  }

  if (!location || !isLocalDevHost(location.hostname)) {
    return value;
  }

  if (!uploadsPath) {
    return value;
  }

  return `${location.origin}${MEDIA_PROXY_PREFIX}${MEDIA_STREAM_PREFIX}${uploadsPath}`;
}
